export default __webpack_public_path__ + "static/media/equipme.2d7459db.jpg";